"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var $$observable = /* #__PURE__ */function () {
  return typeof Symbol === 'function' && Symbol.observable || '@@observable';
}();

var _default = $$observable;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9zeW1ib2wtb2JzZXJ2YWJsZS50cyJdLCJuYW1lcyI6WyIkJG9ic2VydmFibGUiLCJTeW1ib2wiLCJvYnNlcnZhYmxlIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBTUEsSUFBTUEsWUFBWSxHQUFHLGVBQWlCO0FBQUEsU0FDbkMsT0FBT0MsTUFBUCxLQUFrQixVQUFsQixJQUFnQ0EsTUFBTSxDQUFDQyxVQUF4QyxJQUF1RCxjQURuQjtBQUFBLENBQUQsRUFBckM7O2VBR2VGLFkiLCJzb3VyY2VzQ29udGVudCI6WyJkZWNsYXJlIGdsb2JhbCB7XG4gIGludGVyZmFjZSBTeW1ib2xDb25zdHJ1Y3RvciB7XG4gICAgcmVhZG9ubHkgb2JzZXJ2YWJsZTogc3ltYm9sO1xuICB9XG59XG5cbmNvbnN0ICQkb2JzZXJ2YWJsZSA9IC8qICNfX1BVUkVfXyAqLyAoKCkgPT5cbiAgKHR5cGVvZiBTeW1ib2wgPT09ICdmdW5jdGlvbicgJiYgU3ltYm9sLm9ic2VydmFibGUpIHx8ICdAQG9ic2VydmFibGUnKSgpO1xuXG5leHBvcnQgZGVmYXVsdCAkJG9ic2VydmFibGU7XG4iXX0=